import envVar from '../config/envVars';
import { GradeScale } from '../types/gradeScaleType';
import httpDelete from './httpClient/httpDelete';
import httpGet from './httpClient/httpGet';
import httpPost from './httpClient/httpPost';

const normalizeGradeScale = (s: any): GradeScale => ({
  id: s?._id || s?.id,
  school: s?.school,
  name: s?.name,
  gradeScaling: s?.gradeScaling || {}
});

const getGradeScales = async (schoolName: string) => {
  const response = await httpGet(
    `${envVar.REACT_APP_EXAM_BASE_URL}/schools/${schoolName}/grade-scales`,
    {
      headers: {
        Authorization: `Bearer ${envVar.REACT_APP_EXAM_ACCESS_TOKEN}`
      }
    }
  );

  const data = Array.isArray((response as any)?.data)
    ? (response as any).data
    : response;

  const normalized: GradeScale[] = (data as any[]).map(normalizeGradeScale);
  return normalized;
};

const saveGradeScales = async (schoolName: string, gradeScales: GradeScale) => {
  const response = await httpPost(
    `${envVar.REACT_APP_EXAM_BASE_URL}/schools/${schoolName}/grade-scales`,
    gradeScales,
    {
      headers: {
        Authorization: `Bearer ${envVar.REACT_APP_EXAM_ACCESS_TOKEN}`
      }
    }
  );

  const data = (response as any)?.data ?? response;

  return normalizeGradeScale(data);
};

const deleteGradeScale = async ( gradeScaleId: string) => {
  return httpDelete(
    `${envVar.REACT_APP_EXAM_BASE_URL}/schools/grade-scales/${gradeScaleId}`,
    undefined,
    {
      headers: {
        Authorization: `Bearer ${envVar.REACT_APP_EXAM_ACCESS_TOKEN}`
      }
    }
  );
};

const gradeScale = {
  getGradeScales,
  saveGradeScales,
  deleteGradeScale
};

export default gradeScale;
